import { render, staticRenderFns } from "./Coolant.vue?vue&type=template&id=fb41fc7a&scoped=true&"
import script from "./Coolant.vue?vue&type=script&lang=js&"
export * from "./Coolant.vue?vue&type=script&lang=js&"
import style0 from "./Coolant.vue?vue&type=style&index=0&id=fb41fc7a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb41fc7a",
  null
  
)

export default component.exports